<template>
    <v-dialog
      persistent
      v-model="dialog"
      max-width="1000"
    >
      <v-btn
        flat
        icon
        large
        color="indigo"
        slot="activator"
      >
        <v-icon x-large color="grey lighten-1">remove_red_eye</v-icon>
      </v-btn>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Info
        </v-card-title>

        <v-layout justify-center column>
          <slot/>
        </v-layout>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="closeModal"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
    export default {
      name: "gssTooltip",
      data () {
        return {
          dialog: false
        }
      },
      methods: {
        closeModal () {
          this.dialog = false
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleSettingsFormComponents/GssTooltip.vue